var currencyCode = "{{ cart.currency.iso_code }}";
var currencySymbol = getCurrenySymbol(currencyCode);

const gemstoneApi = "https://whitelabel.buildzone.net/live/graphql/";
const gemstoneListingApi = "gemstoneData";
const gemstoneDetailApi = "gemstoneById";
const gemstoneSearchByReportApi = "gemstoneByStockorcert";
const gemstoneAddToCart = "gemstoneAddToCart";

/*** tps config function to get urls start ***/
var tps_config = {
	"urls": {        
        "loose_gemstone": "/pages/loose-natural-gemstone",
        "lab_gemstone": "/pages/loose-lab-gemstone",
        "loose_gemstone_detail": "/pages/gemstone-details",
	}
}
/*** tps config function to get urls end ***/

/*** get currency symbol start ***/
function getCurrenySymbol(CurrenyCode) {
	var currency_symbol;
	switch (CurrenyCode) {
		// for now we have only single currency*- USD

		case 'USD':
			currency_symbol = '$';
			break;
        case 'GBP':
			currency_symbol = '£';
			break;

		default:
			currency_symbol = '£';
	}

	return currency_symbol;
}
/*** get currency symbol end ***/

/*** addCommas in price start ***/
function addCommas(price) {
  price += '';
  x = price.split('.');
  x1 = x[0];
  x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}
/*** addCommas in price end ***/

/*** set selected filters for session filters after reloading page start ***/
function setSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {      
	if (input_value == 'price') {
		$('.selected_filter_container').find('li[data-input="price"]').remove();
	}else if (input_value == 'carat') {
		$('.selected_filter_container').find('li[data-input="carat"]').remove();	
    }else if (input_value == 'ratio') {
		$('.selected_filter_container').find('li[data-input="ratio"]').remove();
	}

	var value = filter_value.split(':');
	if (hasSelectedClass) {
		var html = '';
        var filter_lable = value[1].trim();
         if(input_value == 'price' && input_value != 'carat' && input_value != 'ratio' && input_value != 'cut'  && input_value != 'clarity' && input_value != 'color' && input_value != 'intensity' && input_value != 'gemstone') {
           //filter_lable = filter_lable.replace(/\-/g, ' ');
         }
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter_value="' + filter_value + '"><div class="tps_filter_values">' + filter_lable + '<span class="tps-pendantbuilder-remove-option"></span></div></li>';
		if ($('#' + value[0] + '_container').length > 0) {
			$('#' + value[0] + '_container').append(html);
		} else {
			var elecontainer = '<ul id="' + value[0] + '_container"><span class="tps_applied_filter_lable">' + value[0] + ':</span></ul>';
			$('.selected_filter_container').append(elecontainer);
			$('#' + value[0] + '_container').append(html);
		}      
	} else {
		$('.selected_filter_container').find('li[data-filter_value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}

		if ($('#' + value[0] + '_container li').length == 0) {
			$('#' + value[0] + '_container').remove();
		}
	}
	if ($('.selected_filter_container li').length > 0) {
		$('.tps_selected_filter_wrapper').show();
	} else {
		$('.tps_selected_filter_wrapper').hide();
	}
}
/*** set selected filters for session filters after reloading page end ***/

/*********************************** 
  Diamond Listing Page Filters Start 
/***********************************

/*** Mobile Filter Popup Open start ***/
function openfilter(){
  $(".tps_diamond_main_filter").addClass('tps_diamond_mobile_filters');
  $('body').addClass('tps_open_mob_filter');
}
/*** End ***/

/*** Apply Filter Popup Close Start ***/
function applyfilter(){
   $(".tps_diamond_main_filter").removeClass('tps_diamond_mobile_filters');
   $('body').removeClass('tps_open_mob_filter');
}
/*** End ***/ 

/*** Mobile Filter Popup Close Start ***/
function closeFilter() {
   $(".tps_diamond_mobile_filters").removeClass('tps_diamond_mobile_filters');
   $(".tps_diamond_mobile_filters").fadeToggle();
   $('body').removeClass('tps_open_mob_filter');
}
/*** End ***/

/*** in mobile filter overly click popup close Start ***/
$(document).on("click", ".tps_diamond_main_filter", function(e) {
  e.stopPropagation();
  var container = $(".tps_diamond_filter_div");
  if(!container.is(e.target) && container.has(e.target).length === 0){
     $(".tps_diamond_main_filter").removeClass('tps_diamond_mobile_filters');
     $(".tps_diamond_mobile_filters").fadeToggle();
     $('body').removeClass('tps_open_mob_filter');
  }    
});
/*** End ***/

/*** Diamond Carat Filter Start ***/
var minDiamondCarat = parseFloat($('#diamondMincarat').val());
var maxDiamondCarat = parseFloat($('#diamondMaxcarat').val());
var carat = [];

/* Carat Calibreation Start*/ 
for (i = minDiamondCarat; i < 1; i = i + 0.01) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 1; i < 2; i = i + 0.05) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 2; i < 3; i = i + 0.10) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 3; i < maxDiamondCarat; i = i + 0.15) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
/* Carat Calibreation End*/ 

carat.push(maxDiamondCarat);
Shopify.money_format = '&pound;{{amount}}';
var currency_symbol = "£";

function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}

function get_index(value, array) {
	var pos = 0
	for (i = 0; i < array.length; i++) {
		if (array[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}

function carat_slider_render(start, end, option) { 
    var start2 = getClosestNum(start, carat);
	var end2 = getClosestNum(end, carat);   
	var start1 = get_index(start2, carat);
	var start11 = get_index(start, carat);
	var end11 = get_index(end, carat);
	var end1 = get_index(end2, carat);
  
	var settingSelected = jQuery("#setting").val();

    var pendant_setting = localStorage.getItem("pendant_setting");
    var ring_setting = localStorage.getItem("ring_setting");

    var min_carat = parseFloat($("#diamondMincarat").val()).toFixed(2);
    var max_carat = parseFloat($("#diamondMaxcarat").val()).toFixed(2);
  
     //session carat filter selected
     var isSelected = false;
     if(parseFloat(start).toFixed(2) != min_carat || parseFloat(end).toFixed(2) != max_carat){
       isSelected = true;
     }  
       
     var caratTitle = 'Carat: '+start + ' ct.'+' - '+end + ' ct.';
     setSelectedFilter(caratTitle,"carat_slider_render('"+min_carat+"', '"+max_carat+"','true')",isSelected,'carat');
     //end
  
	jQuery("#carat-slider").slider({      
		range: true,
		min: 0,
		max: carat.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {  
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			//disable min max slider if setting selected
			if (settingSelected == 1 && (parseFloat(start) > parseFloat(carat[parseInt(ui.values[0])]) || parseFloat(end) < parseFloat(carat[parseInt(ui.values[1])]))) {
				return false;
			}
          
			$("#carat_from").val(carat[parseInt(ui.values[0])] + ' ct.');
			$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
			$('#carat_to').val(carat[parseInt(ui.values[1])] + ' ct.');
			$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}			

			if (option) {  
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');               

                //applied filter code start here                              
                 var isSelected = false;                        
                 if(carat[parseInt(ui.values[0])] != min_carat || carat[parseInt(ui.values[1])] != max_carat){
                       isSelected = true;
                 }else if(localStorage.getItem("ring_setting") != null){                   
                   if(carat[parseInt(ui.values[0])] == min_carat || carat[parseInt(ui.values[1])] == max_carat){                    
                     isSelected = true;
                   }                   
                 }

                setTimeout(function(){  
                    var caratLeft = $('#carat_left_hidden').val();
                    var caratRight = $('#carat_right_hidden').val();
                    var caratTitle = 'Carat: '+caratLeft+ ' ct.'+' - '+caratRight+ ' ct.';
                    //var caratTitle = 'Carat: '+start+ ' ct.'+' - '+end+ ' ct.';
                    setSelectedFilter(caratTitle,"carat_slider_render('"+min_carat+"', '"+max_carat+"','true')",isSelected,'carat');
                    //end 
    
                    var reportFlag = jQuery('#tps_search_by_report_no').val();                
                    if(reportFlag == ''){
                      graphqlDataCall();
                    }
                }, 20);
    			               
			}
           
		}

	});

    
    start = start ? start : minDiamondCarat;
    $("#carat_from").val(start + ' ct.');
    $("#carat_to").val(end + ' ct.');
    $('#carat_left_hidden').val(start);
    $('#carat_right_hidden').val(end);
    
}


function replace_carat_from() {

	var min_carat_value = minDiamondCarat;
 
	var settingSelected = jQuery("#setting").val();
  

	if (jQuery('#carat_from').val() == '') {
		var value = parseFloat(jQuery('#carat_left_hidden').val()).toFixed(2);
		jQuery('#carat_from').val(parseFloat(value).toFixed(2) + ' ct.');
		return false;
	} else {
		var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_from').val()).toFixed(2);
	}
	
	var value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_to').val());
	if (isNaN(value) != false) {
		var value = parseFloat(minDiamondCarat).toFixed(2);
		alert("Please enter value in number");
		jQuery('#carat_from').val(value + ' ct.');
	} else if (value > value1) {
		alert('Incorrect carat range!');
		$('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2) + ' ct.');
		return false;
	} else if (carat_value < min_carat_value) {
		alert('Incorrect carat range!');
		$('#carat_from').val((parseFloat(min_carat_value).toFixed(2)) + " ct.");
		carat_slider_render(min_carat_value, value1, true);
		return false;
	} else if (settingSelected == 1 && (hidden_carat_value > carat_value)) {
		alert('selected setting can match with diamond greater than ' + carat_value);
		jQuery('#carat_from').val(hidden_carat_value + " ct.");
		return false;
	}
	$('#carat_left_hidden').val(value);
	$('#carat_right_hidden').val(value1);

	carat_slider_render(value, value1, true);

}

function replace_carat_to() {
	var max_carat_value = parseFloat(maxDiamondCarat).toFixed(2);
	var settingSelected = jQuery("#setting").val();
	if (jQuery('#carat_to').val() == '') {
		var value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		jQuery('#carat_to').val(parseFloat(value).toFixed(2) + ' ct.');
		return false;
	} else {
		var hidden_carat_value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_to').val()).toFixed(2);
	}

	value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_from').val());
    
	if (isNaN(value) != false) {
		var value = parseFloat(maxDiamondCarat).toFixed(2);
		alert("Please enter value in number");
		jQuery('#carat_to').val(value + ' ct.');
	} else if (parseFloat(value) > parseFloat(max_carat_value)) {
		alert('Incorrect carat range!');
		jQuery('#carat_to').val(hidden_carat_value + " ct.");
		return false;
	} else if (value1 > value) {
		alert('Incorrect carat range!');
		$('#carat_to').val(hidden_carat_value + ' ct.');
		return false;
	}else if (settingSelected == 1 && (hidden_carat_value < carat_value)) {
		alert('Selected setting can match with diamond less than ' + carat_value);
		jQuery('#carat_to').val(hidden_carat_value + " ct.");
		return false;
	}
   
	$('#carat_right_hidden').val(value);
	$('#carat_left_hidden').val(value1);

	carat_slider_render(value1, value, true);
}
/*** Diamond Carat Filter End ***/

/*** Diamond Price Filter End ***/
var price = [];
var minDiamondPrice = $('#diamondMinprice').val();
var maxDiamondPrice = $('#diamondMaxprice').val();

for (var i = 95; i < 1000; i = i+1) {
  price.push(i);
};
for (var i = 1000; i < 2500; i = i+3) {
  price.push(i);
};
for (var i = 2500; i < 5000; i = i+15) {
  price.push(i);
};
for (var i = 5000; i < 7000; i = i+18) {
  price.push(i);
};
for (var i = 7000; i < 10000; i = i+20) {
  price.push(i);
};
for (var i = 10000; i < 15000; i = i+25) {
  price.push(i);
};
for (var i = 15000; i < 25000; i = i+200) {
  price.push(i);
};
for (var i = 25000; i < 57658; i = i+300) {
  price.push(i);
};


price.push(parseInt(maxDiamondPrice));

function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}

var diamondMinprice = $('#diamondMinprice').val();
var diamondMaxprice = $('#diamondMaxprice').val();

function price_slider_render(start, end, option) {

    var start2=getClosestNum(start,price);
    var end2=getClosestNum(end,price);  
    var start1=get_priceindex(start2); 
    var start11=get_priceindex(start);
    var end11=get_priceindex(end);
    var end1=get_priceindex(end2); 

     //session price filter selected
     var isSelected = false;
     if(start != diamondMinprice || end != diamondMaxprice){
       isSelected = true;
     }

    var priceTitle = 'Price: '+Shopify.formatMoney(start*100, theme.moneyFormat)+' - '+Shopify.formatMoney(end*100, theme.moneyFormat);
     //var priceTitle = 'Price: '+currencySymbol+addCommas(start)+' - '+currencySymbol+addCommas(end);
 
    setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
    //end
  
   jQuery('#price-slider').slider({
       range: true,       
         min: 0,
         max: price.length-1,
         values: [ start1,end1 ],
         step:0.1,
       slide: function (event, ui) {
       // emptyResultDiv();
         
         if ((ui.values[0]) > (ui.values[1])) { 
            return false; 
        }
          jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
          jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
         
          var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
          jQuery('#price_from').val(price_form);
          var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
          jQuery('#price_to').val(price_to);
         
          option = true;
       }, change: function (event, ui) {
         if(option == true) {
           emptyResultDiv();
           
           jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
           jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
           var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])].toFixed(0)*100, theme.moneyFormat);
           jQuery('#price_from').val(price_form);

           var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])].toFixed(0)*100, theme.moneyFormat);
           jQuery('#price_to').val(price_to);      
  
           //applied filters 
           var isSelected = false;
           if(price[parseInt(ui.values[0])] != diamondMinprice || price[parseInt(ui.values[1])] != diamondMaxprice){
              isSelected = true;
           } 
           
           var priceTitle = 'Price: '+price_form+' - '+price_to;
           setSelectedFilter(priceTitle,"price_slider_render('"+diamondMinprice+"', '"+diamondMaxprice+"','true')",isSelected,'price');
          //end

           jQuery('#page_no').val(1);
    	   jQuery('#pagination').val('');
           
           var reportFlag = jQuery('#tps_search_by_report_no').val();                
           if(reportFlag == ''){
             graphqlDataCall();
           }
           return false;
         }else if(option == false){      
           
             jQuery('#price_left_hidden').val(start);
             jQuery('#price_right_hidden').val(end);

             var price_form = ""+Shopify.formatMoney(start*100, theme.moneyFormat);
             jQuery('#price_from').val(price_form);
             var price_to = ""+Shopify.formatMoney(end*100, theme.moneyFormat);
             jQuery('#price_to').val(price_to);

             jQuery('#page_no').val(1);
             jQuery('#pagination').val('');
          
             graphqlDataCall();     
             option = true;
             return false;
         }
       
       }
     });

    var start_num = parseInt(start);
	var end_num = parseInt(end);

	var start_dec = start_num.toFixed(0);
	var end_dec = end_num.toFixed(0);

	jQuery('#price_left_hidden').val(start_dec);
	jQuery('#price_right_hidden').val(end_dec);
	jQuery('#price_from').val(currency_symbol + " " + addCommas(start_dec));
	jQuery('#price_to').val(currency_symbol + " " + addCommas(end_dec));
}

function get_priceindex(value) {
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_to() {
	if (jQuery('#price_to').val() == '') {
		var value = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
       jQuery('#price_to').val(formatted_price); 
		return false;
	} else {
		var value = jQuery('#price_to').val();
        value = value.replace('£', '');
	}

	//var value1 = jQuery('#price_from').val();
   var value1 = jQuery('#price_left_hidden').val();
  
	value = value.replace(/[^\d\.]/g, '');
	value1 = value1.replace(/[^\d\.]/g, '');

    if(value.indexOf('.')!=-1){    
      value = value.replace(/\./g, '');
  	  value1 = value1.replace(/\./g, '');    
    }else if(value.indexOf(',')!=-1){
       value=value.replace(/[^\d\.]/g, '');
       value1=value1.replace(/[^\d\.]/g, '');
    }

	value = parseInt(value);
	value1 = parseInt(value1);

	if (isNaN(value) != false) {
		var value = maxDiamondPrice;
		alert("Please enter value in number");
		jQuery('#1000000').val(currency_symbol + value);
	} else if (value > maxDiamondPrice) {        
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
        jQuery('#price_to').val(formatted_price);   
		return false;
	} else if (value1 > value) {      
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
      jQuery('#price_to').val(formatted_price); 
		return false;
	} else if (value1 == '') {
		jQuery('#price_from').val(value1);
	}

	jQuery('#price_right_hidden').val(value.toFixed(0));
	jQuery('#price_left_hidden').val(value1.toFixed(0));
	price_slider_render(value1, value, false);

}

function replace_price_from() {
	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
       jQuery('#price_from').val(formatted_price);
		return false;
	} else {
		var value = jQuery('#price_from').val();
        value = value.replace('£', '');
	}
	
    var value1 = jQuery('#price_right_hidden').val();

    if(value.indexOf('.')!=-1){    
      value = value.replace(/\./g, '');
      value1 = value1.replace(/\./g, '');    
    }else if(value.indexOf(',')!=-1){
       value=value.replace(/[^\d\.]/g, '');
       value1=value1.replace(/[^\d\.]/g, '');
    }

	value = parseInt(value);
	value1 = parseInt(value1);

	if (isNaN(value) != false) {
		var value = minDiamondPrice;
        var formatted_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
		alert("Please enter value in number");
        jQuery('#price_from').val(formatted_price);
	} else if (value < minDiamondPrice) {
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_left_hidden').val());
        var formatted_price = ""+Shopify.formatMoney(valLimit*100, theme.moneyFormat);
        jQuery('#price_from').val(formatted_price);
		return false;
	} else if (value > value1) {
		alert('Incorrect price range!');
		price_slider_render(price[0], value1, false);
		return false;
	}

	jQuery('#price_left_hidden').val(value.toFixed(0));
	jQuery('#price_right_hidden').val(value1.toFixed(0));
	price_slider_render(value, value1, false);

}
/*** Diamond Price Filter End ***/

/*** Diamond Ratio Filter Start ***/
var ratio = [];

for (i = 0.1; i < 3.6; i = i + 0.1) {
	var dec = i.toFixed(1);
	ratio.push(dec);
}

var min_ratio_filter = 0.1;
var max_ratio_filter = 3.5;

function ratio_slider_render(start, end, option) {
	var start2 = getClosestNum(start, ratio);
	var end2 = getClosestNum(end, ratio);
	var start1 = get_index(start2, ratio);
	var start11 = get_index(start, ratio);
	var end11 = get_index(end, ratio);
	var end1 = get_index(end2, ratio);
    
     //session depth filter selected
     var isSelected = false;      
     if(start != min_ratio_filter || end != max_ratio_filter){
       isSelected = true;
     }

     var ratioTitle = 'Ratio: '+start+' - '+end;
     setSelectedFilter(ratioTitle,"ratio_slider_render('"+min_ratio_filter+"', '"+max_ratio_filter+"','true')",isSelected,'ratio');
     //end
  
	jQuery("#ratio-slider").slider({
		range: true,
		min: 0,
		max: ratio.length-1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			$("#ratio_from").val(ratio[parseInt(ui.values[0])]);
			$('#ratio_left_hidden').val(ratio[parseInt(ui.values[0])]);
			$('#ratio_to').val(ratio[parseInt(ui.values[1])]);
			$('#ratio_right_hidden').val(ratio[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}	

			if (option) {               
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');	

                $("#ratio_from").val(ratio[parseInt(ui.values[0])]);
    			$('#ratio_left_hidden').val(ratio[parseInt(ui.values[0])]);
    			$('#ratio_to').val(ratio[parseInt(ui.values[1])]);
    			$('#ratio_right_hidden').val(ratio[parseInt(ui.values[1])]);
                              
                 //applied filter start
                 var isSelected = false;               
                 if(ratio[parseInt(ui.values[0])] != min_ratio_filter || ratio[parseInt(ui.values[1])] != max_ratio_filter){
                       isSelected = true;
                 }
                var ratioTitle = 'Ratio: '+ratio[parseInt(ui.values[0])] + ' - '+ratio[parseInt(ui.values[1])];
                setSelectedFilter(ratioTitle,"ratio_slider_render('"+min_ratio_filter+"', '"+max_ratio_filter+"','true')",isSelected,'ratio');
    			
            }
                //end
            
              var reportFlag = jQuery('#tps_search_by_report_no').val();                
              if(reportFlag == ''){
                graphqlDataCall();
              }
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#ratio_from").val(Start_limit);
	$("#ratio_to").val(End_limit);
	$('#ratio_left_hidden').val(start);
	$('#ratio_right_hidden').val(end);
}

function replace_ratio_from() {

	var min_ratio_value = 0.1;

	if (jQuery('#ratio_from').val() == '') {
		var value = parseFloat(jQuery('#ratio_left_hidden').val());
		jQuery('#ratio_from').val(value);
		return false;
	} else {
		var ratio_value = parseFloat(jQuery('#ratio_from').val());
		var hidden_ratio_value = $('#ratio_left_hidden').val();
	}
	
	var value = ratio_value;
	
	var ratio_value1_comma = value;
	value = ratio_value1_comma;

	var value1 = parseFloat($('#ratio_to').val());
	
	if (isNaN(value) != false) {
		var value = 0.1;
		alert("Please enter value in number");
		jQuery('#ratio_from').val(value);
	} else if (value > value1) {
		alert('Incorrect ratio range!');
		var value = parseFloat(jQuery('#ratio_left_hidden').val());
		jQuery('#ratio_from').val(value);
		return false;
	} else if (depth_value < min_depth_value) {
		alert('Incorrect ratio range!');
		$('#ratio_from').val(min_depth_value);
		ratio_slider_render(min_depth_value, value1, true);
		return false;
	}

	$('#ratio_left_hidden').val(value);
	$('#ratio_right_hidden').val(value1);

	ratio_slider_render(value, value1, true);
}

function replace_ratio_to() {

	var max_ratio_value = 3.5;

	if (jQuery('#ratio_to').val() == '') {
		var value = parseFloat(jQuery('#ratio_right_hidden').val());
		jQuery('#ratio_to').val(value);
		return false;
	} else {
		var ratio_value = parseFloat(jQuery('#ratio_to').val());
		var hidden_ratio_value = $('#ratio_right_hidden').val();
	}	
	value = ratio_value;
	var ratio_value1_comma = value;
	value = ratio_value1_comma;

	var value1 = parseFloat($('#ratio_from').val());

	if (isNaN(value) != false) {
		var value = 3.5;
		alert('Please enter value in number');
		jQuery('#ratio_to').val(value);
	} else if (value1 > value) {
		alert('Incorrect ratio range!');
		var value = parseFloat(jQuery('#ratio_right_hidden').val());
		jQuery('#ratio_to').val(value);
		return false;
	} else if (value > max_ratio_value) {
		alert('Incorrect ratio range!');
		$('#ratio_to').val(max_ratio_value);
		ratio_slider_render(value1, max_ratio_value, true);
		return false;
	}

	$('#ratio_right_hidden').val(value);
	$('#ratio_left_hidden').val(value1);

	ratio_slider_render(value1, value, true);
}
/*** Diamond Ratio Filter End ***/

/*** Clarity,Color,Cut,Polish,Symmetry,Fluorescence,Report Remove Applied Filters Start ***/
function removeColorFilter(color){
  jQuery('.color_slider_wrap input[value="'+color+'"]').click();
}

function removeClarityFilter(clarity){
  jQuery('.clarity_slider_wrap input[value="'+clarity+'"]').click();
}

function removeIntensityFilter(intensity){      
  //cut = cut.toUpperCase();
  jQuery('.intensity_slider_wrap input[data-value="'+intensity+'"]').click();
}

function removeTreatmentFilter(treatment){      
  //polish = polish.toUpperCase();
  jQuery('.treatment_slider_wrap input[value="'+treatment+'"]').click();
}

function removeOriginFilter(origin){      
  // symmetry = symmetry.toUpperCase();
  jQuery('.origin_slider_wrap input[value="'+origin+'"]').click();
}

function removeShapeFilter(shape){          
  jQuery('.shape_list .'+shape+'_select').click();
}

function removeGemstoneFilter(gemstone){          
  jQuery('.gemstone_list .'+gemstone+'_select').click();
}

function removeLabFilter(lab){  
  jQuery('.lab_wrap input[value="'+lab+'"]').click();
}    
/*** End ***/

/*** Diamond List View Sorting Filter Start ***/
function sorting_data(sorting, className) {
    emptyResultDiv();
  
	var sortorder = '';
	var clas = className;

	jQuery('.datagrid-sort').each(function() {
		if (jQuery(this).hasClass('fa-angle-up')) {
			jQuery(this).removeClass('fa-angle-up').addClass('fa-angle-down');
		}
	});
    
	if ((mySelection[1] == sorting) && (mySelection[2] == 'asc')) {
		sortorder = 'desc';
		jQuery(clas).find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
	} else {
		sortorder = 'asc';
		jQuery(clas).find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
	}

    //grid view
    var sort_value = ''+sorting+'_'+sortorder;     
    var sort_text = jQuery('.'+sort_value).attr('value'); 
     
    jQuery('.sortvaluename').text(sort_text);  
  
	jQuery('#sort_call').val(sorting);
	jQuery('#sort_dir').val(sortorder);

	mySelection[1] = jQuery('#sort_call').val();
	mySelection[2] = jQuery('#sort_dir').val();
 
	jQuery('#page_no').val(1);
	jQuery('#pagination').val('');
	graphqlDataCall();
}
/*** Diamond List View Sorting Filter End ***/

/**** Diamond Grid View Sorting Filter Start ***/
/*** Sort Dropdown Hide Show Start **/
$(document).on("click", ".dropdown", function() {
  if(jQuery('#dropdown').css('display') !== 'none'){		
      jQuery('#dropdown').css('display', 'none');	
  }else {		
      jQuery('#dropdown').css('display', 'block');
  }
});
/*** End ***/

/*** On Mouse Leave Dropdown Hide Start ***/
$(document).on("mouseleave", ".tps-sort-filter", function(e) {
  e.stopPropagation();
  jQuery("#dropdown").hide();    
});
/*** End ***/

$(document).on("click", ".sort_option", function() {
  emptyResultDiv();
  
  jQuery('.tps_sort').find('i').addClass('fa-angle-down').removeClass('fa-angle-up'); 
  jQuery('#dropdown-menu').css("display", "none");	
  
  var sort_by = $(this).attr('data-sort');
  var sort_title = $(this).attr('data-title');
  var sort_type = $(this).attr('data-type');
  var sort_class = $(this).attr('data-class');
  
  jQuery('#sort_call').val(sort_by); 
  jQuery('#sort_dir').val(sort_type);

  if(sort_type=="asc"){
      sort_order="Low to high";
  }else{
      sort_order="High to low";
  }
  jQuery('.sortvaluename').html('<span>'+sort_title+ ' ('+sort_order+')</span>');

  //list view sort field arrow icon changes
  if ((mySelection[1] == sort_by) && (sort_type == 'asc')) {
      jQuery('.'+sort_class).find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
  } else {
      jQuery('.'+sort_class).find('i').removeClass('fa-angle-down').addClass('fa-angle-up');		
  }
  //end

  jQuery('#page_no').val(1);
  jQuery('#pagination').val('');
  graphqlDataCall();
  
});
/**** Diamond Grid View Sorting Filter End ***/

/*********************************** 
  Diamond Listing Page Filters End 
***********************************/

/*** Diamond List View Detail Info Section Start ***/
function getListViewInfoSection(diamondData,dia_price,placeHolderImage) {
  var detailInfo = '';
  
  var diamond_type = getGemstoneType(diamondData);
  var diamond_name = getGemstoneName(diamondData,diamond_type);
  var diamond_image = diamondData.gemstoneImage;    
  var gemstone_shape = diamondData.shape; 
  var measurements = getGemstoneMeasurement(diamondData); 
  var page_no = jQuery('#page_no').val(); 
  
  detailInfo += '<div class="tps_diamondlist_detail_info tps_diamond_detail_info_'+diamondData.gemstoneId+'" style="display:none;">';
  detailInfo += '<span class="tps_diamondlist_detail_view_close" data-id="'+diamondData.gemstoneId+'"></span>';
  
  detailInfo += '<div class="tps_diamondlist_detail_view_media">';
  if(diamondData.color != 'White'){
    detailInfo += '<img class="tps_diamondlist_detail_img" data-placeholder-img="'+placeHolderImage+'" alt="'+diamond_name+'" title="'+diamond_name+'" src="'+diamond_image+'" onerror="imgError(this,`'+placeHolderImage+'`);" style="">';  
  }else{
    detailInfo += '<img class="tps_diamondlist_detail_img" data-placeholder-img="{{ "'+gemstone_shape.toLowerCase()+'_generic.png" | asset_url }}" alt="'+diamond_name+'" title="'+diamond_name+'" src="'+diamond_image+'" onerror="imgError(this,`{{ "'+gemstone_shape.toLowerCase()+'_generic.png" | asset_url }}`);" style="">';  
  }
  
  detailInfo += '<div class="tps_diamondlist_detail_view_title">'+diamond_name+'</div>';
  detailInfo += '<div class="tps_diamondlist_detail_view_price">'+dia_price+'</div>';
  detailInfo += '</div>';
  detailInfo += '<div class="tps_diamondlist_detail_view_info_table">';
  
  if(diamondData.certificateNumber != '' && diamondData.certificateNumber != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Report Number</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.certificateNumber+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.shape != '' && diamondData.shape != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Shape</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.shape+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.caratWeight != '' && diamondData.caratWeight != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Carat Weight (ct.)</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.caratWeight+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.color != '' && diamondData.color != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Color</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.color+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.clarity != '' && diamondData.clarity != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Clarity</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.clarity+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.gemstoneType != '' && diamondData.gemstoneType != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Stone Type</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.gemstoneType+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.fancyColorIntensity != '' && diamondData.fancyColorIntensity != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Color Intensity</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.fancyColorIntensity+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.origin != '' && diamondData.origin != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Origin</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.origin+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.treatment != '' && diamondData.treatment != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Treatment</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.treatment+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.cut != '' && diamondData.cut != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Cut</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.cut+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.lab != '' && diamondData.lab != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Report</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.lab+'</span>';  
    detailInfo += '</div>';
  }

  if(measurements != '' && measurements != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">Measurements (mm)</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+measurements+'</span>';  
    detailInfo += '</div>';
  }

  if(diamondData.ratio != '' && diamondData.ratio != 'NA'){
    detailInfo += '<div class="tps_diamondlist_detail_view_info_row">';
    detailInfo += '<span class="tps_diamondlist_detail_view_info_title">L/W Ratio</span>';  
    detailInfo += '<span class="tps_diamondlist_detail_view_info_value">'+diamondData.ratio+'</span>';  
    detailInfo += '</div>';
  }

  detailInfo += '</div>';

  detailInfo += '<div class="tps_diamondlist_detail_view_btn_row">';
  detailInfo += '<button class="tps_diamondlist_detail_view_btn" data-id="'+diamondData.gemstoneId+'" data-page="'+page_no+'">View Gemstone</button>';
  detailInfo += '</div>';
    
  detailInfo += '</div>';

  return detailInfo;
}
/*** Diamond List View Detail Info Section End ***/

/*** Diamond Grid View Detail Info Section Start ***/
function getGridViewInfoSection(diamondData,dia_price) {
  var detailGridInfo = '';
  
  var measurements = getGemstoneMeasurement(diamondData); 
  var gemstone_shape = diamondData.shape;
  
  detailGridInfo += '<div class="tps-diamondlist-item-info tps_diamond_info_'+diamondData.gemstoneId+'" style="display:none;">';
  detailGridInfo += '<span class="tps-diamondlist-item-info-close tps_diamond_info_close" data-id="'+diamondData.gemstoneId+'"></span>';
  if(diamondData.certificateNumber != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Report Number</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.certificateNumber+'</span>';
      detailGridInfo += '</div>';
  }
  if(gemstone_shape != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Shape</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+gemstone_shape+'</span>';
      detailGridInfo += '</div>';
  }
  if(diamondData.caratWeight != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Carat Weight (ct.)</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.caratWeight+'</span>';
      detailGridInfo += '</div>';
  }
  if(diamondData.color != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Color</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.color+'</span>';
      detailGridInfo += '</div>';
  }          
  if(diamondData.gemstoneType != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Stone Type</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.gemstoneType+'</span>';
      detailGridInfo += '</div>';
  }
  if(diamondData.origin != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Origin</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.origin+'</span>';
      detailGridInfo += '</div>';
  }
  if(diamondData.treatment != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Treatment</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.treatment+'</span>';
      detailGridInfo += '</div>';
  }
  if(diamondData.fancyColorIntensity != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Color Intensity</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.fancyColorIntensity+'</span>';
      detailGridInfo += '</div>';
  }
  if(diamondData.clarity != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Clarity</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.clarity+'</span>';
      detailGridInfo += '</div>';
  }
  if(diamondData.cut != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Cut</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.cut+'</span>';
      detailGridInfo += '</div>';
  }
  if(diamondData.lab != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Lab</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.lab+'</span>';
      detailGridInfo += '</div>';
  }     
  if(measurements != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">Measurements (mm)</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+measurements+'</span>';
      detailGridInfo += '</div>';
  }       
  if(diamondData.ratio != ''){
      detailGridInfo += '<div class="tps-diamondlist-item-info-row">';
      detailGridInfo += '<span class="tps-diamondlist-item-info-label">L/W Ratio</span>';
      detailGridInfo += '<span class="tps-diamondlist-item-info-value">'+diamondData.ratio+'</span>';
      detailGridInfo += '</div>';
  }
 
  detailGridInfo += '</div>';       

  return detailGridInfo;
}
/*** Diamond Grid View Detail Info Section End ***/

/**** Grid View Broken Image Fixes Start ****/ 
function imgError(image,defaultImage) {
    image.onerror = "";
    image.src = defaultImage;
    return true;
}
/**** End ****/

/*** Get Query Parameter Array from URL ***/
function getQueryMap(query) {
    if(typeof query !== 'string') {
       return null;
    }
    
    var toType = function(a) {
      return ({}).toString.call(a).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }, map = {};
    
  // map the hit query into a proper object
  query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, function (match, key, value) {
      if (key in map) {
          // the key already exists, so we need to check if it is an array, if not, make it an array and add the new value
          if (toType(map[key]) !== 'array') {
              // it's not an array - make it an array
              map[key] = [map[key]];
          }
          // push the new value into the array
          map[key].push(value);
      } else {
          // put the value into the map
          map[key] = value;
      }
  });
  return map;
}
/*** End ***/

/*** Mobile Gallery Functinality Start ***/ 
$(document).on("click", ".tps_dots", function() {
  var data_thumb = jQuery(this).attr("data-thumb");  
  jQuery(".tps_dots").removeClass("active"); 
  jQuery(this).addClass("active");
  
  jQuery(".tps_mobile_gallery_image").hide(); 
  jQuery(".tps_image_"+data_thumb).show(); 
});
/*** End ***/

/**** List View Diamond Info Section Onclick Open Start ****/
jQuery(document).on("click", ".diamond_row", function(e) {
    // e.stopPropagation();
	var data_id = $(this).attr("data-id");
    var container = $(".tps_diamondlist_detail_info"); //diamond info container
    
    // If the target of the click isn't the container
	if(!container.is(e.target) && container.has(e.target).length === 0){
      if(jQuery(this).hasClass("diamond_row_active")){
          jQuery('.tps_diamondlist_view_'+data_id).removeClass("tps_arrow_up");
        
          jQuery('.table_rows').removeClass("diamond_row_active"); 
        
          jQuery('.tps_diamondlist_detail_info').css("display", "none");
          jQuery('.tps_diamond_detail_info_'+data_id).slideUp('slow');   
      }else{
          jQuery('.tps_diamondlist_view').removeClass("tps_arrow_up");
          jQuery('.tps_diamondlist_view_'+data_id).addClass("tps_arrow_up");
        
          jQuery('.table_rows').removeClass("diamond_row_active");    
          jQuery('.tps_diamondlist_detail_info').css("display", "none");         
                 
          jQuery('.tps_diamond_detail_info_'+data_id).slideDown('slow'); 
        
          //adjust scroll position when diamond info display  
          var listItem 	= jQuery(this);
          var itemInfoDiv = listItem.find('.tps_diamond_detail_info_'+data_id);	
          scrollToListItem(listItem, itemInfoDiv);          
          //end
      }  
    }
});
/*** End ***/

/*** scroll to open list view item quick info div ***/
function scrollToListItem(listItem, listItemInfoDiv) {
    if (listItemInfoDiv.is(':visible')) {
        var listItemTop 	 	= listItem.offset().top;          
        var scrollPosition 		= listItemTop;
        jQuery('html, body').animate(
            {			
                scrollTop: scrollPosition,
            }, 
            {
                duration : 600,
                complete : function() {
                  listItem.addClass('diamond_row_active');
                },
            }
        );
    }
}
/*** End ***/

/**** List View Diamond Info Section Onclick Close Start ****/
jQuery(document).on('click','.tps_diamondlist_detail_view_close',function(e){
   e.preventDefault(); 
   var data_id = jQuery(this).attr('data-id');
   jQuery('.tps_diamond_detail_info_'+data_id).slideUp('slow');	
   jQuery('.tps_diamondlist_view_'+data_id).removeClass('tps_arrow_up');	
});
/**** End ****/
              
/**** Grid View Diamond Info Section Onclick Open Start ****/
jQuery(document).on('click', '.tps_diamond_info_span', function(e) {
	e.stopPropagation();
	jQuery('.tps-diamondlist-item-info').css("display", "none");
	var data_id = jQuery(this).attr('data-id');
	jQuery('.tps_diamond_info_' + data_id).slideDown('slow');
});
/**** End ****/

/**** Grid View Diamond Info Section Onclick Close Start ****/
jQuery(document).on('click','.tps_diamond_info_close',function(e){
   e.stopPropagation();
   var data_id = jQuery(this).attr('data-id');
   jQuery('.tps_diamond_info_'+data_id).slideUp('slow');	
});
/**** End ****/

function sessionStoredSortCall(sort_call,sort_dir) {
  //list view
  jQuery(".datagrid-sort").removeClass('fa-angle-up').addClass('fa-angle-down');
  if(sort_dir == 'desc'){
    jQuery(".datagrid-sort-i-"+sort_call).removeClass('fa-angle-down').addClass('fa-angle-up');
  }    

  //grid view
  var sort_value = ''+sort_call+'_'+sort_dir;      
  var sort_text = jQuery('.'+sort_value).attr('value'); 
  jQuery('.sortvaluename').text(sort_text);       
}

/*** Empty Diamond Result Div On Filter Click Start ***/
 function emptyResultDiv(flag){
    jQuery(".tps-diamondlist-result-grid-view-items-list").html(""); //on filter apply empty grid view
    jQuery(".tps_diamond_listing").html(""); //on filter apply empty list view     

    //Applied filter code start 
    var filter_value = localStorage.getItem("diamond_search_report");
    filter_value = jQuery.trim(filter_value);
    var filterTitle = 'ReportNo: '+filter_value;    
    var filterFunction = "removeReportFilter('"+filter_value+"')";        
    var hasClass = false;
    setSelectedFilter(filterTitle,filterFunction,hasClass,filter_value);
    //end     
 }
/*** End ***/ 

/*** Reset Filter Popup Start ***/
function resetFilterOpen() {
  jQuery(".tps_reset_popup").fadeToggle();
}
/*** End ***/

/*** Get Certificate File URL Start ***/
function getCertificateUrl(lab,certificateNo,carat) {
  var certificateFile = '';
  switch(lab)
    {
      case "GIA":
          certificateFile = 'https://www.gia.edu/cs/Satellite?reportno='+certificateNo+'&childpagename=GIA%2FPage%2FReportCheck&pagename=GIA%2FDispatcher&c=Page&cid=1355954554547#main-content';
          break;
      case "IGI":
          certificateFile = 'http://www.igiworldwide.com/verify.php?r='+certificateNo;
          break;
      case "HRD":
          certificateFile = 'https://my.hrdantwerp.com/?record_number='+certificateNo+'&weight='+carat;
          break;
      case "AGS":
          certificateFile = 'https://www.agslab.com/reportTypes/pdqr.php?StoneID='+certificateNo+'&Weight='+carat+'&D=1';
          break;
      default:
          certificateFile = "";
    }
  return certificateFile;
}
/*** End ***/

/*** Get Daimond ID From Url Start ***/
function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}    
/*** End ***/

/*** Gemstone detail page functions start ****/

/*** Get Gemstone Type Start ***/
function getGemstoneType(gemstoneData) {
  var type = gemstoneData.gemstoneSubType;
  if(type == 'white'){
    type = 'Natural';
  }else{
    type = 'Lab';
  }
  return type;
}
/*** End ***/

/*** Get Gemstone Meta Title ***/
function getGemstoneDetailPageMetaTitle(gemstoneData,type,shop_name) {
  var meta_title = gemstoneData.caratWeight+" Carat "+gemstoneData.shape+" Shape "+type+" Gemstone | "+gemstoneData.lab+" Certified - "+shop_name; 
  return meta_title;
}
/*** End ***/ 

/*** Get Gemstone Meta Description ***/
function getGemstoneDetailPageMetaDescription(gemstoneData,type,shop_name) {
  var meta_description = "Shop for a "+gemstoneData.caratWeight+ " carat "+gemstoneData.shape.toLowerCase()+" "+type.toLowerCase()+" gemstone at "+shop_name+". This diamond is certified by "+gemstoneData.lab+", featuring a "+gemstoneData.clarity+" and "+gemstoneData.color+" color rating.";
  return meta_description;
}
/*** End ***/ 

/*** Get Gemstone Name Start ***/
function getGemstoneName(gemstoneData,type) {
  var gemstone_title = gemstoneData.caratWeight + " Carat " + gemstoneData.shape + " Shape "+ type +" "+gemstoneData.gemstoneType+" Gemstone ";
  return gemstone_title;
}
/*** End ***/ 

/*** Get Gemstone Description Start ***/
function getGemstoneDescription(gemstoneData,type) {
  var gemstone_desc = "This " + gemstoneData.caratWeight + " carat, " + gemstoneData.color + " color gemstone, rated as having " + gemstoneData.clarity + " clarity with a " + gemstoneData.shape + " shape  supplied with a " + gemstoneData.lab + " grading report.";
  return gemstone_desc;
}
/*** End ***/ 

/*** Get Gemstone Measurement Start ***/
function getGemstoneMeasurement(gemstoneData) {
  if(gemstoneData.depth != '0.0'){
    var gem_measurements = gemstoneData.length+" * "+gemstoneData.width+" * "+gemstoneData.depth;
  }else{
    var gem_measurements = gemstoneData.length+" * "+gemstoneData.width;
  }
  
  return gem_measurements;
}
/*** End ***/